export default function (app) {
  app.directive("numeric-only", {
    mounted(el) {
      el.addEventListener("keydown", (e) => {});
    },
  });

  app.directive("long-press", {
    bind(el, binding, vnode) {
      el.dataset.longPressTimeoutId = "0";

      const onpointerup = () => {
        clearTimeout(parseInt(el.dataset.longPressTimeoutId));

        if (vnode.componentInstance) {
        }
      };
    },
  });

  app.directive("money-format", {
    mounted(el) {
      el.addEventListener("input", (e) => {
        let value = e.target.value;
        value = value.replace(/[^0-9.]/g, "");
        //숫자와 소수점만 허용

        value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        //쉼표로 천 단위 구분
        e.target.value = value;

        el.dispatchEvent(newEvent("input"));
      });
    },
  });

  app.directive("number-format", {
    mounted(el) {
      el.addEventListener("input", (e) => {
        let value = e.target.value;
        e.target.value = value.replace(/[^0-9]/g, "");
        el.dispatchEvent(newEvent("input"));
      });
    },
  });

  app.directive("number2-format", {
    mounted(el) {
      el.addEventListener("input", (e) => {
        let value = e.target.value;
        e.target.value = value.replace(/[^0-9.]/g, "");
        //숫자와 소숫점
        el.dispatchEvent(newEvent("input"));
      });
    },
  });

  app.directive("eng-format", {
    mounted(el) {
      el.addEventListener("input", (e) => {
        let value = e.target.value;
        e.target.value = value.replace(/[^a-zA-Z]/g, "");
        el.dispatchEvent(newEvent("input"));
      });
    },
  });
}
